import React, { useEffect } from 'react'

import clsx from 'clsx'

interface BackdropBaseProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}

const BackdropBase = ({ isOpen, onClose, children }: BackdropBaseProps) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen, onClose])

  return (
    <div className={clsx('fixed inset-0 z-[1002] flex items-center justify-center', isOpen ? 'block' : 'hidden')}>
      <div
        className='absolute inset-0 bg-black/50'
        onClick={onClose}
        tabIndex={0}
        role='button'
        onKeyDown={() => {}}
      ></div>
      {children}
    </div>
  )
}

export default BackdropBase
